import PropTypes from "prop-types";
import React from "react";
import classes from "./Input.module.css";
import classnames from "classnames";

export const Input = ({ className, block, placeholder, ...props }) =>
  <input
    type="text"
    placeholder={placeholder}
    className={classnames(classes.input, className, {
      [classes.input__block]: block
    })}
    {...props}
  />;

Input.propTypes = {
  block: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string
};

export default Input;



// WEBPACK FOOTER //
// ./src/app/components/UI/Input/Input.js